import React from 'react';
import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { columns } from './datasource';

function AppVersionTable({
  items,
  current,
  pageSize,
  loading,
  total,
  onRowClick,
  onChange,
}) {
  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      pagination={{
        total,
        current,
        pageSize,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
      }}
      rowKey="id"
      tableLayout="fixed"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { AppVersionTable };
